<div class="form-wrapper">
    <mat-tab-group>
        <mat-tab label="{{ 'project-settings.form.title' | translate }}">
            <div class="form-content">
                <div style="display: block; margin-top: 10px">
                    <!-- Disable Language option for now -->
                    <!-- <div class="input-wrapper">
              <span>{{ "project-settings.form.language-selector" | translate }}</span>
              <div class="form-input">
                <mat-select
                  [value]="settings.language"
                  (selectionChange)="onLanguageChange($event.value)"
                >
                  <mat-option
                    *ngFor="let language of languageType"
                    [value]="language.value"
                  >
                    {{ language.label}}
                  </mat-option>
                </mat-select>
              </div>
            </div> -->
                </div>
                <div style="display: block; margin-top: 20px">
                    <div class="input-wrapper" style="width: 100%">
                        <span>{{
                            "project-settings.form.builder-selector" | translate
                        }}</span>
                        <div class="form-input" (click)="onSelectBuilder()">
                            <input
                                matInput
                                type="text"
                                required="required"
                                placeholder="Not Selected"
                                [value]="vessel?.shipyardName"
                                readonly="true"
                            />
                            <mat-icon
                                style="
                                    vertical-align: middle;
                                    transform: translate(-120%, 0);
                                    cursor: pointer;
                                "
                                >link</mat-icon
                            >
                        </div>
                    </div>
                </div>
                <div style="display: block; margin-top: 20px">
                    <div class="input-wrapper">
                        <span>{{
                            "project-settings.form.vessel-selector" | translate
                        }}</span>
                        <div
                            class="form-input"
                            (click)="
                                showVesselList(
                                    vessel.iAPIShipyardId,
                                    vessel.shipyardName
                                )
                            "
                        >
                            <input
                                matInput
                                type="text"
                                required="required"
                                placeholder="Not Selected"
                                [value]="vessel?.name"
                                readonly="true"
                            />
                            <mat-icon
                                style="
                                    vertical-align: middle;
                                    transform: translate(-120%, 0);
                                    cursor: pointer;
                                "
                                >link</mat-icon
                            >
                        </div>
                    </div>
                </div>
                <div
                    style="display: block; margin-top: 20px"
                    *ngIf="hasProjectData()"
                >
                    <div class="input-wrapper">
                        <span>{{
                            "project-settings.form.project-version-selector"
                                | translate
                        }}</span>
                        <div
                            data-cy="settings-project-version"
                            class="form-input"
                            (click)="projectVersionList()"
                        >
                            <input
                                matInput
                                type="text"
                                required="required"
                                placeholder="Not Selected"
                                [value]="vessel?.projectVersion"
                                readonly="true"
                            />
                            <mat-icon
                                style="
                                    vertical-align: middle;
                                    transform: translate(-120%, 0);
                                    cursor: pointer;
                                "
                                >link</mat-icon
                            >
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div mat-dialog-actions class="form-actions">
        <button
            data-cy="settings-save-button"
            class="component-large primary caption"
            [disabled]="!saveIsEnabled()"
            (click)="handleSave()"
        >
            {{ "project-settings.form.confirm" | translate }}
        </button>
    </div>
</div>
